export default {
  props: {
    visibleColumns: Array
  },
  computed: {
    computedCols () {
      let { sortBy, descending } = this.computedPagination

      const cols = this.visibleColumns
        ? this.columns.filter(col => col.required || this.visibleColumns.includes(col.name))
        : this.columns

      return cols.map(col => {
        col.align = col.align || 'right'
        col.__iconClass = `q-table-sort-icon q-table-sort-icon-${col.align}`
        col.__thClass = `text-${col.align}${col.name === sortBy ? ` sorted ${descending ? 'sort-desc' : ''}` : ''}${this.__columnFiltered(col.filter) ? ' filtered' : ''}`
        col.__tdClass = `text-${col.align}`
        return col
      })
    },
    computedColsMap () {
      const names = {}
      this.computedCols.forEach(col => {
        names[col.name] = col
      })
      return names
    }
  },
  methods: {
    __columnFiltered (value) {
      if (!value) {
        return false;
      }

      if (value.constructor === Array && value.length) {
        return true;
      } else if (value.constructor === Object && Object.keys(value).length) {
        return true;
      } else if (value.constructor === String && value !== '') {
        return true
      }

      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/HTable/table-column-selection.js